import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import ViewTrainingClass from "../view";
// import ViewTrainingClassParticipant from "./view";
import EditTrainingClassParticipant from "./edit";
import { MODULE_TRAINING_CLASS } from "variables/constants";

const classParticipantRoutes = [
	generateCRUDRoutes({
		mainTitle: "Participants",
		basePath: "training-classes/:classeId/training-class-participants",
		mainComponent: <ViewTrainingClass />,
	    layout: "/console",	   
	    subTitle:"Class Participants",
	    // viewComponent: <ViewTrainingClassParticipant />,
	    createComponent: <EditTrainingClassParticipant />,
	    editComponent: <EditTrainingClassParticipant />,
		level:5,
		moduleId: MODULE_TRAINING_CLASS,  
			

	})
]

export default classParticipantRoutes;